<template>
  <span class="d-inline-flex align-center flex-wrap">
    <v-chip v-if="estatus === 0" small color="green" dark>Asistencia</v-chip>
    <v-chip v-if="estatus === 1" small color="error" dark>Retardo</v-chip>
    <v-chip v-if="estatus === 2" small color="blue" dark>Descanso</v-chip>
    <v-chip v-if="estatus === 3" small color="purple" dark>Vacaciones</v-chip>
    <v-chip v-if="estatus === 4" small color="pink" dark>Festivo</v-chip>
    <v-chip v-if="estatus == null" small color="orange" dark>Sin Registro</v-chip>

    <v-tooltip v-if="jornadaIncompleta" bottom max-width="300">
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          small
          color="deep-orange darken-2"
          dark
          class="ml-1 mt-1 font-weight-bold estatus-jornada-incompleta"
          label
          v-bind="attrs"
          v-on="on"
        >
          <v-icon left x-small>mdi-calendar-alert</v-icon>
          Jornada inc.
        </v-chip>
      </template>
      <span>
        Jornada incompleta: retardo mayor a 6 min y/o salida antes del horario laboral.
      </span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  name: 'EstatusJornadaCell',

  props: {
    item: {
      type: Object,
      required: true,
    },
    dia: {
      type: Number,
      required: true,
    },
  },

  computed: {
    estatus() {
      return this.item['estatus' + this.dia];
    },
    jornadaIncompleta() {
      return this.item['jornada_incompleta' + this.dia] === 1;
    },
  },
};
</script>

<style scoped>
.estatus-jornada-incompleta {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.02em;
}
</style>
